import { FleetManagementRow } from "../types/FleetManagement-row.types";
import { hasUserOverlappingCheckedInBookingInFleet } from "../../BookingForm/functions/hasOverlappingCheckedInFleetBooking.function";

export type GetBookingModeFleetDataParams = {
  remoteFleetData: FleetManagementRow[];
  filteredByRole: FleetManagementRow[];
  /** ISO date-time strings for the booking range */
  bookingRangeStartIso: string;
  bookingRangeEndIso: string;
  userIdToCheck: string;
  filterBySelectedLocations: (rows: FleetManagementRow[]) => FleetManagementRow[];
};

export type GetBookingModeFleetDataResult = {
  data: FleetManagementRow[];
  hasConflict: boolean;
};

/**
 * Computes table data and conflict flag for fleet booking mode.
 * Pure function to keep the sync effect simple and testable.
 */
export function getBookingModeFleetData(
  params: GetBookingModeFleetDataParams
): GetBookingModeFleetDataResult {
  const {
    remoteFleetData,
    filteredByRole,
    bookingRangeStartIso,
    bookingRangeEndIso,
    userIdToCheck,
    filterBySelectedLocations
  } = params;

  const hasConflict = hasUserOverlappingCheckedInBookingInFleet(
    remoteFleetData,
    bookingRangeStartIso,
    bookingRangeEndIso,
    userIdToCheck
  );

  if (hasConflict) {
    return { data: [], hasConflict: true };
  }

  return {
    data: filterBySelectedLocations(filteredByRole),
    hasConflict: false
  };
}
